import videos, { VideoJsPlayer } from "video.js";
export const Plugin = videos.getPlugin('plugin');

export interface IFallbackOptions {
    handleOnMetaLoaded: () => void;
    handleOnTimeUpdate: () => void;
}

export class FallbackHandlersPlugin extends Plugin {
    constructor(player: VideoJsPlayer, options?: IFallbackOptions) {
        super(player);

        player.on("loadedmetadata", () => {
            options?.handleOnMetaLoaded?.();
        });
        player.on("timeupdate", () => {
            options?.handleOnTimeUpdate?.();
        });
    }
}
